/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Hlavní materiál`
};

const da_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Hovedmateriale`
};

const de_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Hauptmaterial`
};

const en_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Main material`
};

const es_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `material principal`
};

const fr_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Matière principale`
};

const hu_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Fő anyag`
};

const it_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Materiale principale`
};

const nl_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Hoofdmateriaal`
};

const pl_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Materiał główny`
};

const pt_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Material principal`
};

const sv_attributes_main_material = /** @type {(inputs: {}) => string} */ () => {
	return `Huvudsakligt material`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_main_material = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_main_material(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_main_material", locale)
	if (locale === "cs") return cs_attributes_main_material(inputs)
	if (locale === "da") return da_attributes_main_material(inputs)
	if (locale === "de") return de_attributes_main_material(inputs)
	if (locale === "en") return en_attributes_main_material(inputs)
	if (locale === "es") return es_attributes_main_material(inputs)
	if (locale === "fr") return fr_attributes_main_material(inputs)
	if (locale === "hu") return hu_attributes_main_material(inputs)
	if (locale === "it") return it_attributes_main_material(inputs)
	if (locale === "nl") return nl_attributes_main_material(inputs)
	if (locale === "pl") return pl_attributes_main_material(inputs)
	if (locale === "pt") return pt_attributes_main_material(inputs)
	return sv_attributes_main_material(inputs)
};
export { attributes_main_material as "attributes.main_material" }